import React, { useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap';
import { changeSessionTimeUseCase } from '../../di/usecase_module';
import { ChangeSessionTimeRequestDto } from '../../domain/usecases/session/ChangeSessionTimeUseCase';
import { handleError } from '../../presentation/utils/handleError';
import { AppError } from '../../common/erros/AppError';
import { showSuccessMessage } from '../../presentation/utils/showSuccessMessage';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../presentation/redux/store/RootState';
import { UIActions } from '../../presentation/redux/actions/UIActions';
import { handleLogout } from '../../presentation/utils/handleLogout';

export const ModalSessionTime = () => {

    const [minuteSelected, setMinuteSelected] = useState(10 * 60 * 1000);
    const dispatch = useDispatch();
    const uiState = useSelector((s: RootState) => s.uiState);

    function handleHide() {
        dispatch(UIActions.closeSessionTime());
    }
    function onSubmit(e: any) {
        e.preventDefault();
        changeSessionTimeUseCase()
            .execute(new ChangeSessionTimeRequestDto(minuteSelected))
            .then((result) => {
                if (result.status) {
                    showSuccessMessage({
                        message: "Tiempo de sesión cambiado correctamente, es necesario volver a iniciar sesión"
                    }, () => {
                        handleLogout();
                        handleHide();
                    });
                } else {
                    handleError(new AppError(result.message))
                }
            }).catch((e) => {
                handleError(e);
            })

    }

    const optionsInMinutes: Array<OptionSessionTime> = [
        new OptionSessionTime(10 * 60 * 1000, '10 minutos'),
        new OptionSessionTime(20 * 60 * 1000, '20 minutos'),
        new OptionSessionTime(30 * 60 * 1000, '30 minutos'),
        new OptionSessionTime(60 * 60 * 1000, '1 hora'),
        new OptionSessionTime(24 * 60 * 60 * 1000, '1 día')
    ];

    return (
        <Modal
            onHide={handleHide}
            show={uiState.isSessionTimeOpen}
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Header closeButton
                className='gradientBlue colorWhite'>
                <Modal.Title id="contained-modal-title-vcenter">
                    Tiempo de sesión
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={onSubmit}>
                    <Form.Label>Selecciona el tiempo que durará tu sesión</Form.Label>
                    <Form.Group>
                        <Form.Label
                            className='mt-4'
                        >Tiempo de sesión</Form.Label>
                        <Form.Control as="select"
                            value={minuteSelected}
                            onChange={(evt: any) => {
                                setMinuteSelected(evt.target.value)
                            }}>
                            {
                                optionsInMinutes.map((option: OptionSessionTime) => {
                                    return <option key={option.millis} value={option.millis}>{option.description}</option>
                                })
                            }
                        </Form.Control>
                    </Form.Group>

                    <Button className="float-right mt-4" variant="primary" type="submit">
                        Guardar
                    </Button>

                    <Button onClick={handleHide} className="float-right mt-4 mr-4" variant="secondary">
                        Cancelar
                    </Button>
                </Form>
            </Modal.Body>

        </Modal>
    )
}


class OptionSessionTime {
    constructor(
        public millis: number,
        public description: string
    ) { }
}